import { render } from "./Hall.vue?vue&type=template&id=46d141a6"
import script from "./Hall.vue?vue&type=script&lang=js"
export * from "./Hall.vue?vue&type=script&lang=js"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__